
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class ListAppCreditNoteDialog extends Serenity.EntityDialog<ListAppCreditNoteRow, any> {
        protected getFormKey() { return ListAppCreditNoteForm.formKey; }
        protected getIdProperty() { return ListAppCreditNoteRow.idProperty; }
        protected getLocalTextPrefix() { return ListAppCreditNoteRow.localTextPrefix; }
        protected getNameProperty() { return ListAppCreditNoteRow.nameProperty; }
        protected getService() { return ListAppCreditNoteService.baseUrl; }
        protected getDeletePermission() { return ListAppCreditNoteRow.deletePermission; }
        protected getInsertPermission() { return ListAppCreditNoteRow.insertPermission; }
        protected getUpdatePermission() { return ListAppCreditNoteRow.updatePermission; }

        protected form = new ListAppCreditNoteForm(this.idPrefix);

    }
}